import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import 'primeicons/primeicons.css';
import './styles.css';

const app = createApp(App);

// Pinia MUST be registered first before any other plugins
app.use(createPinia());

// Force PrimeVue to always render in Dark Mode so invert(1) trick flips it properly
document.documentElement.classList.add('p-app-dark');

// Uses Aura theme to style components like DatePicker
app.use(PrimeVue, {
  ripple: true,
  theme: {
    preset: Aura,
    options: {
      darkModeSelector: '.p-app-dark', 
    }
  }
});

// Router with auth guard
app.use(router);

// Mount app
app.mount('#app');

// Validate stored token on startup — if expired, user will be redirected to login
import { useUserStore } from './stores/user';
const userStore = useUserStore();
if (userStore.token) {
  userStore.fetchMe();
}
